import {
  Stamp,
  Languages,
  BadgeCheck,
  BookUser,
  Plane,
  ShieldCheck,
} from "lucide-react";

// Public services offered by VENKA WORLD EXPRESS. Used by the header mega-menu
// and the marketing homepage so both always stay in sync.
export const SERVICES = [
  {
    key: "visa",
    to: "/apply/visa",
    icon: Stamp,
    title: "Visa & Immigration",
    desc: "Skilled worker, business, student & visitor visas — full application support.",
  },
  {
    key: "translation",
    to: "/translation",
    icon: Languages,
    title: "Certified Translations",
    desc: "Official document translation in Portuguese, English & French.",
  },
  {
    key: "authentication",
    to: "/authentication",
    icon: BadgeCheck,
    title: "Document Authentication",
    desc: "Legalise academic, professional & civil documents for use abroad.",
  },
  {
    key: "passport",
    to: "/passport",
    icon: BookUser,
    title: "National Passport",
    desc: "Fast-track new passports and renewals with less hassle.",
  },
  {
    key: "flight",
    to: "/flight",
    icon: Plane,
    title: "Flight Tickets",
    desc: "The best fares and routes for your next departure.",
  },
  {
    key: "insurance",
    to: "/insurance",
    icon: ShieldCheck,
    title: "Travel Insurance",
    desc: "Cover for medical needs, delays and lost baggage.",
  },
];

export default SERVICES;
